export default {
  club_name: 'Nordea Open',
  club_name_short: 'nordeaopen',
  stadium_name: '',
  staging_url: 'https://nordeaopen.api.fangroup.io',
  prod_url: 'https://nordeaopen.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/nordeaopen',
  club_logo: '/assets/teams/nordeaopen.png',
  app_name: 'nordeaopen',
  websale_name: 'nordeaopen',
  ntb_team_id: 10075,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'nordeaopen',
  monolithEnabled: false,
  clubWebsiteEnabled: true,
};
